export default __webpack_public_path__ + "static/char-s-04-cht-8aaad55f7af0de2c0cfa818577a5614d.webp";